// In-app modül eğitim playlist'leri. Backend: /api/admin/TutorialPlaylists + /api/admin/TutorialVideos
export interface TutorialPlaylistDto {
  Id: string;
  ModuleKey: string;
  Title: string;
  Subtitle: string;
  Order: number;
  IsActive: boolean;
  VideosCount: number;
}

export interface TutorialVideoDto {
  Id: string;
  TutorialPlaylistId: string;
  Title: string;
  Description: string;
  Order: number;
  DurationSec: number;
  Video: string;
  Poster: string;
  IsActive: boolean;
}

// App rota→anahtar eşlemesiyle senkron kanonik modül anahtarları (playlist ModuleKey seçici).
export const MODULE_KEYS = [
  { Name: "Genel Bakış (dashboard)", EnumId: "dashboard" },
  { Name: "Bisiklet Panosu (bikes-dash)", EnumId: "bikes-dash" },
  { Name: "Bisikletler (bikes)", EnumId: "bikes" },
  { Name: "Müşteriler (customers)", EnumId: "customers" },
  { Name: "Rezervasyonlar (reservations)", EnumId: "reservations" },
  { Name: "Filo Takvimi (calendar)", EnumId: "calendar" },
  { Name: "Kira Sözleşmeleri (contracts)", EnumId: "contracts" },
  { Name: "Bakımlar (maintenance)", EnumId: "maintenance" },
  { Name: "Tedarikçiler (suppliers)", EnumId: "suppliers" },
  { Name: "Sigortalar (insurance)", EnumId: "insurance" },
  { Name: "Finansal Hesaplar (finance)", EnumId: "finance" },
  { Name: "Giderler (expenses)", EnumId: "expenses" },
  { Name: "Hatırlatıcılar (reminders)", EnumId: "reminders" },
  { Name: "Ayarlar (settings)", EnumId: "settings" },
  { Name: "Ofisler (offices)", EnumId: "offices" },
  { Name: "Bölgeler (regions)", EnumId: "regions" },
  { Name: "Ofis Grupları (officegroups)", EnumId: "officegroups" },
];
